
export const DOMAIN = " https://aoljourney.org/api"
export const PUBLIC_DOMAIN = "https://aoljourney.org/public";
export const ENABLE_FORCE_LOGOUT = false;
export const ENABLE_BANNER_SCREEN = false;
export const ENABLE_NOTIFY_USERS = false;

